export var buildEventHandler = function () {
    var subscription = null;
    var dispatch = function (message, options) {
        return subscription === null || subscription === void 0 ? void 0 : subscription(message, options);
    };
    var subscribe = function (callback) {
        subscription = callback;
        return function () {
            subscription = null;
        };
    };
    return { subscribe: subscribe, dispatch: dispatch };
};
//# sourceMappingURL=Provider.events.js.map